import {Component, ViewEncapsulation} from '@angular/core';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {EpostConfigWrapperComponent} from '../epost-config/epost-config-wrapper/epost-config-wrapper.component';
import {
  CustomerBaseDataConfigFormComponent
} from './customer-basedata-config-form/customer-base-data-config-form.component';
import {BookingOptionsConfigFormComponent} from './booking-options-config-form/booking-options-config-form.component';
import {OpenItemImportConfigFormComponent} from './open-item-import-config-form/open-item-import-config-form.component';
import {AuthorizeVisibilityDirective, EsvgFiles, SmtpComponent} from 'frontier';
import {MatIcon} from '@angular/material/icon';
import {AUTHORIZATION_CONFIG} from '../../../config/authorization.config';
import {
  VerificationRulesConfigFormComponent
} from "./verification-rules-config-form/verification-rules-config-form.component";
import {MailTemplateComponent} from 'frontier/browserkit/src/lib/views/mail-template/mail-template.component';
import {SepaConfigFormComponent} from "./sepa-config-form/sepa-config-form.component";

@Component({
  selector: 'app-configuration-overview',
  templateUrl: './configuration-overview.component.html',
  styleUrl: './configuration-overview.component.scss',
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    MatTabContent,
    MatTabLabel,
    EpostConfigWrapperComponent,
    CustomerBaseDataConfigFormComponent,
    BookingOptionsConfigFormComponent,
    OpenItemImportConfigFormComponent,
    MatIcon,
    AuthorizeVisibilityDirective,
    VerificationRulesConfigFormComponent,
    MailTemplateComponent,
    SmtpComponent,
    SepaConfigFormComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ConfigurationOverviewComponent {
  protected readonly EsvgFiles = EsvgFiles;
  protected readonly AUTHORIZATION_CONFIG = AUTHORIZATION_CONFIG;
}
